import { LoadingSpinner } from '@ctw/shared/components/loading-spinner';
import { type ClassName, twx } from '@ctw/shared/utils/tailwind';
import { type PropsWithChildren, useEffect, useState } from 'react';

interface DeferRenderingProps extends PropsWithChildren {
  milliseconds: number;
  message?: string;
  loadingSpinnerClassName?: ClassName;
}

export const DeferRendering = ({
  milliseconds,
  message,
  children,
  loadingSpinnerClassName,
}: DeferRenderingProps) => {
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    const timeoutId = setTimeout(() => setShouldRender(true), milliseconds);
    return () => clearTimeout(timeoutId);
  }, [milliseconds]);

  if (!shouldRender) {
    return (
      <LoadingSpinner centered={true} className={twx(loadingSpinnerClassName)} message={message} />
    );
  }

  return children;
};
